import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "./hooks/useTheme";
import { AnimationProvider } from "./hooks/useAnimation";
import { AuthProvider } from "./hooks/useAuth";
import { router } from "./router";

export default function App() {
  return (
    <ThemeProvider>
      <AnimationProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </AnimationProvider>
    </ThemeProvider>
  );
}
